// extracted by mini-css-extract-plugin
export default {"addButton":"organizations_addButton__zWjCt","row":"organizations_row__BIzkW","col":"organizations_col__shISy"};